import { mixpanel } from '@fiverr-private/obs';

const sendMixPanelEvent = (type, params) => {
    mixpanel.track(type, params);
};

export default sendMixPanelEvent;
